import React, {
	Dispatch,
	PropsWithChildren,
	SetStateAction,
	useState,
} from "react";
import { MainContext } from "./user-information-context";

export type TUser = {
	ssn: string;
	phone_number: string;
};

export type TMainContext = {
	userData: TUser;
	setUserData: Dispatch<SetStateAction<TUser>>;
	removeUserData: () => void;
};

export const defaultUserState: TUser = {
	ssn: "",
	phone_number: "",
};

const STORAGE_KEY = "userData";

const MainProvider: React.FC<PropsWithChildren> = ({ children }) => {
	const [userData, setUserDataState] = useState<TUser>(() => {
		// Initialize state from localStorage if available
		const savedData = localStorage.getItem(STORAGE_KEY);
		return savedData ? (JSON.parse(savedData) as TUser) : defaultUserState;
	});

	const setUserData: Dispatch<SetStateAction<TUser>> = (newData) => {
		setUserDataState((prevData) => {
			const nextData =
				typeof newData === "function" ? newData(prevData) : newData;

			// Save to localStorage
			if (nextData) {
				localStorage.setItem(STORAGE_KEY, JSON.stringify(nextData));
			} else {
				localStorage.removeItem(STORAGE_KEY);
			}

			return nextData;
		});
	};

	function removeUserData() {
		setUserDataState(defaultUserState);
		localStorage.removeItem(STORAGE_KEY);
	}

	return (
		<MainContext.Provider
			value={{
				userData,
				setUserData,
				removeUserData,
			}}
		>
			{children}
		</MainContext.Provider>
	);
};

export default MainProvider;
